<template>
  <div class="rsu">
    <div class="px-4 py-2">
      <v-layout justify-center row wrap>
        <v-flex xs12>
          <div class="text-right">
            <v-btn class="ma-0" @click="$emit('close')" icon><v-icon>close</v-icon></v-btn>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="headline primary--text mb-1">
            <Typography
              h2
              bold
              :label="
                `${
                  editType == 'add' || editType == 'copy' ? 'เพิ่ม' : 'แก้ไข'
                }ข้อมูลแบบฟอร์มโครงการ`
              "
            />
          </div>
        </v-flex>
        <v-flex xs12 class="mb-3 mt-4">
          <div class="pr-3" style="white-space: nowrap">
            <Typography h5 semiBold color="darkGrey" :label="'ชื่อฟอร์ม*'" />
          </div>
          <div
            style="width: 100%"
            class="form-control"
            :class="{ 'has-error': errors.has('ชื่อฟอร์ม') }"
          >
            <input
              v-validate="'required'"
              name="ชื่อฟอร์ม"
              placeholder="กรอกชื่อฟอร์ม"
              v-model="name"
              type="text"
              class="depainput rsu mb-0"
            />
            <span class="text-error" v-if="errors.has('ชื่อฟอร์ม')">{{
              errors.first('ชื่อฟอร์ม')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 class="mb-4 mt-1">
          <v-divider style="border-color:#EEEEEE" />
        </v-flex>
        <v-flex xs12>
          <draggable
            v-model="formitems"
            @start="drag = true"
            @end="dropFormItem"
            handle=".patternCardHeader"
            ghost-class="form-ghost"
          >
            <!-- <v-slide-y-transition group> -->
            <div v-for="(form, k) in formitems" :key="k" class="mb-3">
              <FormItem
                v-model="formitems[k]"
                @onMove="onMoveForm"
                @ondelete="ondelete(k)"
                :formlength="formitems.length"
                :dataindex="k"
              ></FormItem>
            </div>
            <!-- </v-slide-y-transition> -->
          </draggable>
        </v-flex>
        <v-flex xs12 class="mb-2">
          <v-btn class="rsu mx-0 mr-1 icoBtn" round @click="addQuestion(null, 'หัวข้อ')">
            <img
              src="/static/img/datalist.png"
              alt
              class="responsive-img mr-2"
              style="height: 15px"
            />
            เพิ่มหัวข้อ
          </v-btn>
          <v-btn class="rsu mx-0 icoBtn" round @click="addQuestion(null, '')">
            <img src="/static/img/Add.png" alt class="responsive-img mr-2" style="height: 15px" />
            เพิ่มรูปแบบ
          </v-btn>
        </v-flex>
        <v-flex xs12 class="mt-3">
          <div class="pr-3" style="white-space: nowrap">
            <Typography h5 semiBold color="darkGrey" :label="'ตั้งค่าชื่อปุ่ม'" />
          </div>
        </v-flex>
        <v-flex xs12 class="mb-3 mt-3" style="display: flex;justify-content: center;">
          <div
            class="form-control text-xs-center"
            :class="{ 'has-error': errors.has('ชื่อปุ่ม ไม่อนุมัติ') }"
          >
            <v-text-field
              solo
              name="ชื่อปุ่ม ไม่อนุมัติ"
              placeholder="กรอกชื่อปุ่ม ไม่อนุมัติ"
              v-validate="'required'"
              v-model="reject"
              class="editTextBtn  customEditBtn rsu"
              single-line
              :readonly="rejectBtnReadStatus"
            >
              <template v-slot:append>
                <img
                  :src="`/static/icon/${rejectBtnReadStatus ? 'editSvg' : 'checkSvg'}.svg`"
                  alt
                  class="responsive-img mr-2"
                  style="height: 20px;cursor: pointer;"
                  @click="setInputReadOnly('rejectBtnReadStatus')"
                />
              </template>
            </v-text-field>
            <span class="text-error" v-if="errors.has('ชื่อปุ่ม ไม่อนุมัติ')">{{
              errors.first('ชื่อปุ่ม ไม่อนุมัติ')
            }}</span>
          </div>
          <div
            class="form-control text-xs-center"
            :class="{ 'has-error': errors.has('ชื่อปุ่ม อนุมัติ') }"
          >
            <v-text-field
              solo
              name="ชื่อปุ่ม อนุมัติ"
              placeholder="กรอกชื่อปุ่ม อนุมัติ"
              v-validate="'required'"
              v-model="button"
              class="editTextBtn fillBtn customEditBtn rsu"
              single-line
              :readonly="approveBtnReadStatus"
            >
              <template v-slot:append>
                <img
                  :src="
                    `/static/icon/${approveBtnReadStatus ? 'editYellowSvg' : 'checkYellowSvg'}.svg`
                  "
                  alt
                  class="responsive-img mr-2"
                  style="height: 20px;cursor: pointer;"
                  @click="setInputReadOnly('approveBtnReadStatus')"
                />
              </template>
            </v-text-field>
            <span class="text-error" v-if="errors.has('ชื่อปุ่ม อนุมัติ')">{{
              errors.first('ชื่อปุ่ม อนุมัติ')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 class="mb-5 mt-1">
          <v-divider style="border-color:#EEEEEE" />
        </v-flex>
        <v-flex xs12 class="mb-0 mt-3 center">
          <v-btn
            class="rsu customViewBtn"
            :disabled="this.formitems.length < 1"
            @click="showPreview"
            round
            outline
            color="primary"
          >
            <img src="/static/img/eye.png" alt class="responsive-img mr-2" style="height: 15px" />
            ดูตัวอย่าง
          </v-btn>
        </v-flex>
        <v-flex xs12 class="mb-2 mt-1 center">
          <v-btn class="rsu customCancelBtn" @click="$emit('close')" round outline color="primary">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            class="rsu customConfirmBtn"
            :disabled="this.formitems.length < 1"
            :loading="loading"
            @click="onSave"
            round
            depressed
            color="primary"
            >{{ $t('Save') }}</v-btn
          >
        </v-flex>
      </v-layout>
    </div>
    <v-dialog v-model="modalPreview" width="800px">
      <v-card>
        <FormDetail
          :formdata="{ formname: formname, button: button, reject: reject, formitems: formitems }"
          :showPreview="true"
          :showSubquestion="true"
          @close="modalPreview = false"
        ></FormDetail>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FormItem from './FormItem.vue'
import api from '@/api'
import FormDetail from './FormDetail.vue'
import Typography from '@/components/elements/Typography.vue'
import draggable from 'vuedraggable'
export default {
  props: ['editType', 'editdata'],
  data() {
    return {
      formId: 1,
      approveBtnReadStatus: true,
      rejectBtnReadStatus: true,
      modalPreview: false,
      loading: false,
      name: '',
      button: 'อนุมัติ',
      reject: 'ไม่อนุมัติ',
      formitems: [
        {
          rfId: 0,
          imgFile: '',
          formTable: { viewColumn: true, data: [] },
          hideFromMember: false,
          name: '',
          questiontype: 'ข้อความ',
          fields: [],
          isRequired: false,
          value: '',
          value2: '',
          fields2: [],
          digitPosition: 0,
          filename: '',
          fileurl: '',
          defaultOptions: []
        }
      ]
    }
  },
  components: {
    FormItem,
    FormDetail,
    Typography,
    // draggable,
    draggable: {
      extends: draggable,
      inject: ['$validator']
    }
  },
  mounted() {
    if (this.editdata && (this.editType == 'edit' || this.editType == 'copy')) {
      var formdata = JSON.parse(this.editdata.formdata)
      this.button = formdata.button
      this.reject = formdata.reject
      if (this.editType == 'copy') {
        this.name = this.editdata.formname + '_copy'
      } else {
        this.name = this.editdata.formname
      }
      this.formitems = formdata.formitems
    }
  },
  methods: {
    dropFormItem(data) {
      console.log(this.formitems)
    },
    setInputReadOnly(name) {
      console.log(name)
      if (name == 'approveBtnReadStatus') {
        this.approveBtnReadStatus = !this.approveBtnReadStatus
      } else if (name == 'rejectBtnReadStatus') {
        this.rejectBtnReadStatus = !this.rejectBtnReadStatus
      }
    },
    showPreview() {
      this.modalPreview = true
    },
    onMoveForm: function(index, direction) {
      var vm = this

      if (direction == 'up') {
        this.formitems.splice(index, 0, this.formitems.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        this.formitems.splice(index, 0, this.formitems.splice(index + 1, 1)[0])
      }
    },
    addQuestion(index, questiontype) {
      if (questiontype) {
        if (index == null) {
          this.formitems.push({
            rfId: this.formId,
            imgFile: '',
            formTable: { viewColumn: true, data: [] },
            hideFromMember: false,
            name: '',
            questiontype: questiontype,
            fields: [],
            isRequired: false,
            value: '',
            value2: '',
            digitPosition: 0,
            filename: '',
            fileurl: '',
            defaultOptions: []
          })
          this.formId = this.formId + 1
        } else {
          this.formitems.splice(index, 0, {
            rfId: this.formId,
            imgFile: '',
            formTable: { viewColumn: true, data: [] },
            hideFromMember: false,
            name: '',
            questiontype: 'ข้อความ',
            fields: [],
            isRequired: false,
            value: '',
            value2: '',
            digitPosition: 0,
            filename: '',
            fileurl: '',
            defaultOptions: []
          })
          this.formId = this.formId + 1
        }
      } else {
        if (index == null) {
          this.formitems.push({
            rfId: this.formId,
            imgFile: '',
            formTable: { viewColumn: true, data: [] },
            hideFromMember: false,
            name: '',
            questiontype: 'ข้อความ',
            fields: [],
            isRequired: false,
            value: '',
            value2: '',
            digitPosition: 0,
            filename: '',
            fileurl: '',
            defaultOptions: []
          })
          this.formId = this.formId + 1
        } else {
          this.formitems.splice(index, 0, {
            rfId: this.formId,
            imgFile: '',
            formTable: { viewColumn: true, data: [] },
            hideFromMember: false,
            name: '',
            questiontype: 'ข้อความ',
            fields: [],
            isRequired: false,
            value: '',
            value2: '',
            digitPosition: 0,
            filename: '',
            fileurl: '',
            defaultOptions: []
          })
          this.formId = this.formId + 1
        }
      }
      console.log(this.formitems)
    },
    addTitle() {
      this.formitems.push({
        id: this.formId,
        hideFromMember: false,
        name: '',
        questiontype: 'title',
        fields: [],
        isRequired: false,
        value: '',
        value2: '',
        digitPosition: 0,
        filename: '',
        fileurl: '',
        defaultOptions: []
      })
      this.formId = this.formId++
    },
    ondelete(k) {
      this.formitems.splice(k, 1)
    },
    async onSave() {
      var isValid = await this.$validator.validate()
      console.log('isValid', isValid)
      if (isValid) {
        try {
          var formdata = { button: this.button, reject: this.reject, formitems: this.formitems }
          formdata = JSON.stringify(formdata)
          var data = {
            formname: this.name,
            formdata
          }
          this.loading = true
          if (this.editType == 'add' || this.editType == 'copy') {
            var typeapi = 'createdepaprojectform'
          } else {
            var typeapi = 'updatedepaprojectform'
            Object.assign(data, { formid: this.editdata.id })
          }
          console.log('sentdata', formdata)
          api[typeapi](data, (err, response) => {
            this.loading = false
            if (response.responsecode == 200) {
              if (this.editType == 'add' || this.editType == 'copy') {
                this.$emit('onCreate', response.data[0])
              } else {
                this.$emit('onUpdate', { ...data, id: this.editdata.id })
              }
            }
          })
        } catch (error) {}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.icoBtn {
  font-size: 16px;
  font-weight: 600;
  color: #0c2f53 !important;
  background-color: #beccdb !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}
.customCancelBtn {
  font-weight: 700;
  font-size: 16px;
  width: 142px;
  margin: 0 7px;
}
.customConfirmBtn {
  color: yellow !important;
  font-weight: 700;
  font-size: 16px;
  width: 142px;
  margin: 0 7px;
}
.customViewBtn {
  background-color: #e6f0fb !important;
  font-weight: 700;
  font-size: 16px;
  width: 304px;
}
.customEditBtn {
  font-weight: 700;
  font-size: 16px;
  width: 142px;
  margin: 0 7px;
}
.form-ghost {
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/CustomFormManager.vue